import config from "config/config";

const { baseUrl, clientUrl } = config;
/* *********************

********************** */

export default function forgotPassword(email) {
  // const { refresh } = getTokens();
  const endpoint = `${baseUrl}/v1/auth/forgot-password`;
  const options = {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": `${clientUrl || ""}`,
      "Access-Control-Allow-Credentials": true,
    },
    body: JSON.stringify({ email }),
  };
  return fetch(endpoint, options)
    .then((response) => {
      if (response.status !== 200 && response.status !== 201 && response.status !== 204) {
        throw new Error();
      }

      return response;
    })
    .catch((e) => {
      // eslint-disable-next-line
      console.log("error", e);
    });
}
